import { usePutItem } from 'Features/HTTP/RequestHandlers';
import { useResponseHandler, useErrorHandler } from 'Features/HTTP/ResponseHandler';
import apiConfig from 'Application/configurations/apiConfig';
import IUpdateClearing from "./interfaces/IUpdateClearing";
import ILockClearing from './interfaces/ILockClearing';
import { useAccessTokens } from 'Features/Authentication';
import { useTranslation } from 'react-i18next';
import IOpenClearing from './interfaces/IOpenClearing';

function useUpdateClearing () {

    const { t } = useTranslation();
    const putItem = usePutItem();
    const responseHandler = useResponseHandler();
    const errorHandler = useErrorHandler();
    const getToken = useAccessTokens();
    const AccessAsUser = apiConfig.scopes.AccessAsUser;

    /** Create new clearing survey
     * @param {string} companyId - guid of the company
     * @param {string} surveyId - guid of the survey
     * @param {IUpdateClearing} surveyData - object which describes the survey
     **/
    const updateClearing = async (companyId: string = "", surveyId: string="", surveyData: IUpdateClearing | ILockClearing | IOpenClearing) => {

        const basePath = apiConfig.basePath;
        const companyEndpoint = apiConfig.endpoints.companies
        const surveyEndpoint = apiConfig.endpoints.clearings;
        const url = new URL(`${basePath}/${companyEndpoint}/${companyId}/${surveyEndpoint}/${surveyId}`);
        const accessToken = await getToken([AccessAsUser]);

        const options = {
            accessToken: accessToken,
            body: surveyData
        }

        try {

            const response = await putItem(url, options);
         
            return responseHandler(response, "useUpdateClearing", { operation: "update", messageHeader: t("features.clearing.savedSuccessfully"), hide: false });


        } catch (error: any) {

            let problemTitle = error && error.data && error.data.title ? error.data.title : "";
            let body = null;

            if (problemTitle === "Clearing.UpdatePermissionDenied") body = t('features.survey.updatePermissionDenied');
            if (problemTitle === "Company.CompanyDataAccessDenied") body = t('features.company.companyDataAccessDenied');
            if (problemTitle === "Company.NotExist") body = t('features.company.notExist');
            if (problemTitle === "UserAccount.NotExist") body = t('features.account.userAccountNotExist');
            if (problemTitle === "General.RequestorNotExist") body = t('features.survey.requestorNotExist');
            if (problemTitle === "Clearing.NotExist") body = t('features.survey.notExist');
            if (problemTitle === "Clearing.PermanentlyLocked") body = t('features.survey.permanentlyLocked');
            if (problemTitle === "Clearing.Closed") body = t('features.survey.closed');

            return errorHandler(error, "useUpdateClearing", { operation: "update", hide: false, messageBody: body });

        }

    }

    return { updateClearing }

}

export default useUpdateClearing;
